import moment from 'moment';
import { getGlobalState, STATE_KEYS } from '../configs/config_state';

import GLOBAL from '../configs/config_global';

function isCateringDataMissing(cateringData) {
    return(!cateringData || (Object.keys(cateringData) <= 1));
}

export function isCateringFilled(cateringData) {
    if (isCateringDataMissing(cateringData)) return false;

    let isOldCatering = moment.utc(cateringData['created_at'], 'YYYY-MM-DD HH:mm:ss').unix() <= 1582218000,
        isSpecificTruck = cateringData['food_truck_id'] !== 0,
        cateringPushedToMultiple = Number(cateringData['extent_number']) > 1;

    let slotFilled = ((Number(cateringData['total_accepted_truck']) >= GLOBAL.SETTINGS.MAX_CATERING_TRUCKS) && cateringData['child_status'] === 0);

    return(
        (isSpecificTruck || isOldCatering) ?
            (
                cateringPushedToMultiple ?
                    slotFilled
                    :
                    (cateringData['parent_status'] === 1 && cateringData['child_status'] === 0)
            )
            :
            slotFilled
    );
}

export function isHired(cateringData, truckID) {
    if (isCateringDataMissing(cateringData)) return false;
    return(cateringData?.['hired_trucks']?.find((item) => Number(item.id) === Number(truckID)));
}

export function isNotHired(cateringData, truckID) {
    if (isCateringDataMissing(cateringData)) return false;
    return(cateringData?.['not_hired_trucks']?.find((item) => Number(item.id) === Number(truckID)));
}

export function getRequestType(cateringData, truckID) {
    if (isCateringDataMissing(cateringData)) return('N/A');

    // Specific Request
    if (Number(cateringData['food_truck_id']) !== 0) {
        if (Number(cateringData['food_truck_id']) === Number(truckID)) {
            return('YOUR TRUCK');
        }
        else return((cateringData['original_truck']?.cuisine || []).map((item) => item.name).join(', '));
    }
    else return(cateringData['requested_cuisines'] || []).map((item) => item.name).join(', ');
}

export function getAcceptedMessage(acceptedItem) {
    if (isCateringDataMissing(acceptedItem)) return('');

    let message = Number(acceptedItem['food_truck_id']) === getGlobalState(STATE_KEYS.TRUCK_DATA)?.id ?
        'Your truck was specifically requested and you’ve been introduced via email to the client. Please contact the client directly to confirm the event.'
        :
        'You\'ve been introduced via email to the client and you’re one of three trucks in the running. Get your hustle on and land the lead!';

    return(message);
}

export function isFeedbackNeeded(cateringData) {
    if (isCateringDataMissing(cateringData)) return false;

    let isPast = cateringData?.timeObj?.endTime < moment().unix(),
        feedbackNeeded = isPast && (cateringData['confirmed_status'] === 1) && !cateringData['weather']; // Since truck can enter $0 as sales, we check the "weather" field

    return(feedbackNeeded);
}

export function isFeedbackGiven(cateringData) {
    if (isCateringDataMissing(cateringData)) return false;
    return(!!cateringData['weather']);
}

export function isCateringMissed(cateringData) {
    return(
        // Catering already sent out more than 5 days ago
        (
            ((moment().unix() - moment.utc(cateringData['truck_received_at'], 'YYYY-MM-DD HH:mm:ss').unix())
            >=
            (5 * 86400))
            &&
            (cateringData['child_status'] !== 1 && !isNotHired(cateringData) && !isHired(cateringData)) // Still in Pending
        )
        ||
        // Catering is stopped and this lead is in pending -> missed
        (
            cateringData['is_finished'] && (cateringData['child_status'] === 0)
        )
        ||
        isCateringFilled(cateringData)
        ||
        (
            cateringData['child_status'] === 0 &&
            isNotHired(cateringData, getGlobalState(STATE_KEYS.TRUCK_DATA)?.id) &&
            (
                cateringData?.timeObj.startTime < moment().unix()
                ||
                cateringData['is_finished']
            )
        )
    );
}
